import React, { FC, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { format } from 'date-fns';
import { DATE_FORMAT, useViewModel } from '@utils';
import {
  Button, EditMeeting, FilterViewModel, Loader, MeetingViewModel, PlannerBluePlus,
} from '@components';
import { CalendarViewModel } from '@views';
import { FilterMobile } from '../../../components/filter/FilterMobile';
import { ScheduleViewModel } from './ScheduleViewModel';
import { Month } from './Month';
import '../../../styles/views/calendarPage/schedule.scss';

export const ScheduleCalendar: FC = observer(() => {
  const schedule = useViewModel(ScheduleViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);
  const filterViewModel = useViewModel(FilterViewModel);

  const page = useRef<HTMLDivElement>();

  useEffect(() => {
    schedule.getSchedule();
  }, []);

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = page?.current;
    const diff = 200;
    if (scrollHeight - (scrollTop + clientHeight) <= diff) {
      schedule.getSchedule();
    }
  };

  const openMeeting = (id: number, calendarId: number, start?: Date, end?: Date) => {
    meetingViewModel.loadMeetingById(id, calendarId === -1 ? 'inner_meeting' : 'outer_meeting', start, end);
    meetingViewModel.setEditable(false);
  };

  const addNewMeeting = () => {
    filterViewModel.resetEmployeeAndRoom();
    filterViewModel.setOpenPanel(false);
    meetingViewModel.openAddNewMeetingForm(calendarViewModel.today);
  };

  return (
    <>
      <FilterMobile />
      {meetingViewModel.meetingData && <EditMeeting />}
      <div 
        className="schedule-page" 
        id="schedule-page" 
        ref={page} 
        onScroll={handleScroll} 
        hidden={!!meetingViewModel.meetingData}
      >
        <div className="days">
          {schedule.filteredSchedule?.map((month) => (
            <Month
              key={month.months}
              monthSchedule={month}
              todayString={format(schedule.today, DATE_FORMAT)}
              openMeeting={openMeeting}
            />
          ))}
          {schedule.isLoading && <Loader />}
        </div>
        <Button
          onClick={addNewMeeting}
          className="fixed-button mobile-add-meeting-button"
          icon={<PlannerBluePlus />}
        />
      </div>
    </>
  );
});
